import { ActionIcon, Button, Grid, Group, Paper, Text, Tooltip, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { Buffer } from 'buffer';
import {
    ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title as TitleChart,
    Tooltip as TooltipChart
} from 'chart.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { FaCar, FaCheck, FaSquare, FaWifi } from 'react-icons/fa';
import { useApp } from '../contexts/app.context';
import { useAuth } from '../contexts/auth.context';
import { GET_COMPANIES_STATISTICS } from '../services/statistics';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    TitleChart,
    TooltipChart,
    Legend
);

export default function Admin(){
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [devices, setDevices] = useState<any>({});
    const [vehicles, setVehicles] = useState<any>({});
    const [filters, setFilters] = useState<any>({
        companies: [],
    });

    let { userData, companies: userCompanies } = useAuth();
    const { confirmDialog } = useApp();

    const handleExport = (items) => {
        setLoadingExport(true);

        let csvText = [
            [
                "Dispositivo - Modelo",
                "Dispositivo - IMEI",
                "Dispositivo - Number",
                "Dispositivo - SSID",
                "Dispositivo - Data Cadastro",
                "Dispositivo - Última Comunicação",
                "Veículo - Placa",
                "Veículo - Marca",
                "Veículo - Modelo",
                "Veículo - Data Cadastro",
                "Cliente - Nome",
                "Cliente - Empresa",
            ],
            ...(items.total ?? []).map(({ device, vehicle, company }) => [
                device?.model?.title,
                device?.props?.DEV_ID,
                device?.props?.CHIP_NO,
                device?.props?.SSID_CHIP,
                moment(device?.createdAt).format("DD/MM/YYYY HH:mm"),
                device?.lastCommunication ? moment(device?.lastCommunication).format("DD/MM/YYYY HH:mm") : null,
                vehicle?.license_plate,
                vehicle?.brand,
                vehicle?.model,
                moment(vehicle?.createdAt).format("DD/MM/YYYY HH:mm"),
                (vehicle?.customers ?? [])[0]?.name,
                company?.name,
            ])
        ].map(items => items.map(it => `"${it ?? ""}"`).join(",")).join("\n")
    
        const byteCharacters = Buffer.from(csvText, "utf-8");
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters[i]; }
        const byteArray = new Uint8Array(byteNumbers);
    
        const blob = new Blob([byteArray], { type: "application/csv" });
    
        const url = URL.createObjectURL(blob);;
        const a = document.createElement('a');
        a.href = url;
        a.download = `Dispositivos_e_Veiculos_Satify.csv`;
        a.click();
        URL.revokeObjectURL(url);

        setLoadingExport(false);
    }

    const loadData = () => {
        console.log(filters);
        setLoading(true);
        
        const companies = userCompanies.reduce((pv, { company }) => {
            return pv.concat(company.master
                ? [
                    company._id,
                    ...company.children.map(c => c._id),
                ]
                : []
            )
        }, [])
        GET_COMPANIES_STATISTICS({ companies })
        .then(res => {
            setLoading(false);
            setData(res);
        })
        .catch(err => {
            setLoading(false);
            showNotification({ message: err.message, color: "red" })
        })
    }

    useEffect(loadData, [userCompanies])
    useEffect(() => {
        let devices = { total: [], on: [], off: [], none: [] };
        let vehicles = { total: [], on: [], off: [], none: [] };

        for(let cId in {...data?.companies}){
            if((filters.companies ?? []).includes(cId)){
                const selfDevices = data.companies[cId].devices;
                const selfVehicles = data.companies[cId].vehicles;

                devices.total = devices.total.concat(selfDevices);
                devices.on = devices.on.concat(selfDevices.filter(d => (
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") < 2 &&
                    d?.lastHistory?.power === "on"
                )));
                devices.off = devices.off.concat(selfDevices.filter(d => (
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") < 2 &&
                    d?.lastHistory?.power === "off"
                )));
                devices.none = devices.none.concat(selfDevices.filter(d => (
                    !d?.lastHistory ||
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") >= 2
                )));
                
                vehicles.total = vehicles.total.concat(selfVehicles);
                vehicles.on = vehicles.on.concat(selfVehicles.filter(d => (
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") < 2 &&
                    d?.lastHistory?.power === "on"
                )));
                vehicles.off = vehicles.off.concat(selfVehicles.filter(d => (
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") < 2 &&
                    d?.lastHistory?.power === "off"
                )));
                vehicles.none = vehicles.none.concat(selfVehicles.filter(d => (
                    !d?.lastHistory ||
                    moment().diff(moment(d?.lastHistory?.datetime), "hours") >= 2
                )));
            }
        }

        setDevices(devices);
        setVehicles(vehicles);

        console.log(devices);
    }, [data, filters]);

    useEffect(() => {
        setFilters(f => ({
            ...f,
            companies: userCompanies.map(c => c?.company?._id)
        }))
    }, [userCompanies]);

    const renderCompany = (company) => {
        const checked = filters.companies.includes(company._id);
        return <UnstyledButton
            style={{width: '100%'}}
            onClick={() => {
                setFilters(f => ({
                    ...f,
                    companies: checked
                        ? f.companies.filter(c => c !== company._id)
                        : [...f.companies, company._id]
                }))
            }}
            mt="md"
        >
            <Group>
                <ActionIcon
                    variant='light'
                    color={checked ? "green" : "gray"}
                >{checked ? <FaCheck /> : <FaSquare />}</ActionIcon>
                <Text style={{flex: 1}} size="xs">{(company.name ?? "").toUpperCase()}</Text>
                <Tooltip label="Veículos">
                    <Button
                        size="xs"
                        leftIcon={<FaCar />}
                        variant='light'
                        color="gray"
                    >
                        {({...data?.companies}[company._id]?.vehicles ?? []).length}
                    </Button>
                </Tooltip>
                <Tooltip label="Dispositivos">
                    <Button
                        size="xs"
                        leftIcon={<FaWifi />}
                        variant='light'
                        color="gray"
                    >
                        {({...data?.companies}[company._id]?.devices ?? []).length}
                    </Button>
                </Tooltip>
            </Group>
        </UnstyledButton>
    }

    return <div>
        <Grid>
            <Grid.Col md={4}>
                {userCompanies
                .filter(c => c.company.master)
                .sort((a,b) => a.company.name > b.company.name ? 1 : -1)
                .map((master) => {
                    const allCompanies = [master.company, ...master.company.children];
                    const allSelected = !allCompanies.some(c => !filters.companies.includes(c._id))
                    const withoutCompanies = filters.companies.filter(c => !allCompanies.map(c => c._id).includes(c));
                    return <Paper mb="sm" p="md">
                        <Group>
                            <ActionIcon
                                variant='subtle'
                                onClick={() => {
                                    setFilters(f => ({
                                        ...f,
                                        companies: allSelected
                                            ? withoutCompanies
                                            : [...withoutCompanies, ...allCompanies.map(c => c._id)]
                                    }))
                                }}
                                color={allSelected ? "green" : "gray"}
                            >{allSelected ? <FaCheck /> : <FaSquare />}</ActionIcon>
                            <Text style={{flex: 1}} c="gray">{master.company.name}</Text>
                            
                        </Group>
                        {
                            [
                                renderCompany(master.company),
                                ...(master?.company?.children ?? [])
                                    .sort((a,b) => a.name > b.name ? 1 : -1)
                                    .map(renderCompany),
                            ]
                        }
                    </Paper>
                },[])}
            </Grid.Col>
            <Grid.Col md={8}>
                <Paper p="md">
                    <Grid>
                        <Grid.Col md={4}>
                            <Doughnut
                                options={{
                                    responsive: true,
                                    plugins: {
                                        legend: { display: true, position: 'bottom' as const },
                                        title: { position: 'top', display: true, text: `Veículos (${(vehicles.total ?? []).length})` },
                                    },
                                }}
                                data={{
                                    labels: [
                                        "Ligados",
                                        "Desligados",
                                        "Sem Comunicação",
                                    ],
                                    datasets: [
                                        {
                                            label: 'Data',
                                            data: [
                                                (vehicles.on ?? []).length,
                                                (vehicles.off ?? []).length,
                                                (vehicles.none ?? []).length,
                                            ],
                                            backgroundColor: [
                                                'rgba(75, 192, 192, 0.2)',
                                                'rgba(255, 99, 132, 0.2)',
                                                'rgba(255, 206, 86, 0.2)',
                                                'rgba(54, 162, 235, 0.2)',
                                                'rgba(153, 102, 255, 0.2)',
                                                'rgba(255, 159, 64, 0.2)',
                                            ],
                                            borderColor: [
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(153, 102, 255, 1)',
                                                'rgba(255, 159, 64, 1)',
                                            ],
                                        }
                                    ]
                                }}
                            />

                            <Button
                                fullWidth
                                onClick={() => handleExport(vehicles)}
                                loading={loadingExport}
                                variant="light"
                                mt="xs"
                            >Exportar</Button>
                        </Grid.Col>
                        <Grid.Col md={4}>
                            <Doughnut
                                options={{
                                    responsive: true,
                                    plugins: {
                                        legend: { display: true, position: 'bottom' as const },
                                        title: { position: 'top', display: true, text: `Dispositivos (${(devices.total ?? []).length})` },
                                    },
                                }}
                                data={{
                                    labels: [
                                        "Ligados",
                                        "Desligados",
                                        "Sem Comunicação",
                                    ],
                                    datasets: [
                                        {
                                            label: 'Data',
                                            data: [
                                                (devices.on ?? []).length,
                                                (devices.off ?? []).length,
                                                (devices.none ?? []).length,
                                            ],
                                            backgroundColor: [
                                                'rgba(75, 192, 192, 0.2)',
                                                'rgba(255, 99, 132, 0.2)',
                                                'rgba(255, 206, 86, 0.2)',
                                                'rgba(54, 162, 235, 0.2)',
                                                'rgba(153, 102, 255, 0.2)',
                                                'rgba(255, 159, 64, 0.2)',
                                            ],
                                            borderColor: [
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(153, 102, 255, 1)',
                                                'rgba(255, 159, 64, 1)',
                                            ],
                                        }
                                    ]
                                }}
                            />

                            <Button
                                fullWidth
                                onClick={() => handleExport(devices)}
                                loading={loadingExport}
                                variant="light"
                                mt="xs"
                            >Exportar</Button>
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Grid.Col>
        </Grid>

    </div>
}